import type { LoopingStore } from "../../../../../../stores/automation/looping.store";
import { RecordListInputConfig_Reference } from "@smartsuite/automation-engine-api";
import type { ActionCandidate } from "../../../../../../types/candidate";

export const getOptionFromSource = (
  looping: LoopingStore,
  actions: ActionCandidate[],
): string | undefined => {
  const source = looping.source;

  switch (source?.oneofKind) {
    case "recordList": {
      const recordList = source.recordList;
      if (recordList === undefined) {
        return undefined;
      }
      switch (recordList.recordList.oneofKind) {
        case "actionReference":
          return `${recordList.recordList.actionReference.actionId}_${recordList.recordList.actionReference.instanceId}`;
        case "reference":
          return recordList.recordList.reference ===
            RecordListInputConfig_Reference.FROM_TRIGGER
            ? "trigger"
            : undefined;
      }
      break;
    }
    case "outputReference": {
      const outputReference = source.outputReference;
      if (outputReference === undefined) {
        return undefined;
      }
      if (outputReference.source.oneofKind === "triggerReference") {
        return "trigger";
      } else if (outputReference.source.oneofKind === "actionReference") {
        const instanceId: number =
          outputReference.source.actionReference.instanceId;
        const action = actions.find(
          (action) => action.actionReference?.instanceId === instanceId,
        );
        const actionId = action?.actionReference?.actionId;

        return actionId ? `${actionId}_${instanceId}` : undefined;
      }
      // we doesn't support loopItem yet
      return undefined;
    }
  }
};
